import sageLogo from '@/assets/sage-logo.png';

interface AppIconProps {
  size?: number;
  className?: string;
}

export const AppIcon = ({ size = 192, className = '' }: AppIconProps) => {
  return (
    <img 
      src={sageLogo}
      alt="SAGE Logo"
      className={className}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        borderRadius: `${size * 0.22}px`,
      }}
    />
  );
};
